import { useContext, useEffect, useState } from "react";
import PageHeading from "../../Components/PageHeading/PageHeading";

import axios from "axios";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import moment from "moment";
import { Pagination } from "@mui/material";
import "./PurchaseHistory.css"
import swal from "sweetalert";
import { useLocation } from "react-router-dom";


const PurchaseHistory = () => {

  const { AIuser } = useContext(UserAuthContext);
  const [transactionDetails, setTransactionDetails] = useState([]);

  useEffect(() => {
    const getTransaction = async () => {
      const response = await axios.get(
        `https://backend.whalesai.com/api/v1/payment/${AIuser?._id}`
      );
      setTransactionDetails(response?.data?.result?.reverse());
    };
    getTransaction();
  }, [AIuser?._id]);


  const [showFullId, setShowFullId] = useState(false);

  const location = useLocation();

  const isPaymentSuccess = location?.state?.success;
  const credits = location?.state?.credits;

  useEffect(() => {
    const paymentAlert = async () => {
      try {
        if (isPaymentSuccess == true) {
          swal({
            title: "Success!",
            text: `You have purchased ${credits} credits successfully!`,
            icon: "success",

            button: "OK",

            className: "modal_class_success",
          });
        }
      } catch (err) {
        console.log("Error from dashboard", err);
      }
    };
    paymentAlert();
  }, [isPaymentSuccess, credits]);

  const handleMouseOver = (index) => {
    setShowFullId({
      index: index,
      isTrue: true,
    });
  };

  const handleMouseOut = (index) => {
    setShowFullId({
      index: index,
      isTrue: false,
    });
  };
  const handleTouchStart = (index) => {
    setShowFullId({
      index: index,
      isTrue: true,
    });
  };

  const handleTouchEnd = (index) => {
    setShowFullId({
      index: index,
      isTrue: false,
    });
  };

  const itemsPerPage = 6;

  const [currentPage, setCurrentPage] = useState(1);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  // Get the current page's data
  const paginatedData = transactionDetails?.slice(startIndex, endIndex);


  const handlePageChange = (event, page) => {
    // scroll to half of the page
    window.scrollTo(0, window.innerHeight / 3);
    setCurrentPage(page);
  };

  useEffect(() => { window.scroll(0, 0) }, []);


  return (
    <div>
      <PageHeading title={"PURCHASE HISTORY"} />

      <div className="container account-container pb-5 purchase-history-wrapper">
        <div className="table-container">
          <table style={{ minWidth: "600px" }} className="transaction-table">
            <thead>
              <tr>
                <th className="text-start" style={{ width: '40px' }}>#</th>
                <th className="text-start">Date of Purchase</th>
                <th className="text-start">Transaction ID</th>
                <th className="text-start" style={{ minWidth: '100px' }}>Price</th>
                <th className="text-start">Credits Bought</th>
                <th className="text-start">Date of Expiry</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData?.length > 0 ?
                paginatedData?.map((details, index) => (
                  <tr
                    key={details._id}
                  >
                    <td className="text-start">
                      <span className="purchase-row-index">{startIndex + index + 1}</span>
                    </td>
                    <td className="text-start">
                      <span className="purchase-date">{moment(details?.createdAt).format("DD MMM YYYY")}</span>
                    </td>
                    <td
                      className="text-start maintain-max-width"
                      onMouseOver={() => handleMouseOver(index)}
                      onMouseOut={() => handleMouseOut(index)}
                      onTouchStart={() => handleTouchStart(index)}
                      onTouchEnd={() => handleTouchEnd(index)}
                    >
                      <span className="purchase-txn-id">
                        {showFullId.isTrue && showFullId.index === index
                          ? details?.paymentId
                          : `${details?.paymentId.slice(0, 4)}******${details?.paymentId.slice(-4)}`}
                      </span>
                    </td>
                    <td className="text-start">
                      <span className="purchase-price-badge">$ {details?.price}</span>
                    </td>
                    <td className="text-start">
                      <span className="purchase-credits-badge">
                        {parseInt(details?.credits).toLocaleString()}
                      </span>
                    </td>
                    <td className="text-start">
                      <span className="purchase-date-expiry">
                        {moment(details?.createdAt).add(parseInt(details?.data?.expire), 'months').format('DD MMM YYYY')}
                      </span>
                    </td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={6} className="purchase-empty-state">
                      No purchase history found.
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-center text-light mt-3">
          <Pagination
            shape="rounded"
            count={Math.ceil(transactionDetails?.length / itemsPerPage)}
            page={currentPage}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseHistory;
